// Text colors
export var textColors = {
  standard: "var(--ds-text, #253858)",
  standardLink: "var(--ds-link, #0052CC)",
  blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
  red: "var(--ds-text-accent-red-bolder, #172B4D)",
  yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
  green: "var(--ds-text-accent-green-bolder, #172B4D)",
  teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
  purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
  lime: "var(--ds-text-accent-lime-bolder, #37471F)",
  magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
  orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
  grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
  blueLight: "var(--ds-text-accent-blue, #0747A6)",
  redLight: "var(--ds-text-accent-red, #42526E)",
  yellowLight: "var(--ds-text-accent-yellow, #42526E)",
  greenLight: "var(--ds-text-accent-green, #006644)",
  tealLight: "var(--ds-text-accent-teal, #42526E)",
  purpleLight: "var(--ds-text-accent-purple, #403294)",
  limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
  magentaLight: "var(--ds-text-accent-magenta, #943D73)",
  orangeLight: "var(--ds-text-accent-orange, #974F0C)",
  greyLight: "var(--ds-text-accent-gray, #42526E)"
};

// Border colors - Hardcoded for Visual Refresh
export var borderColors = {
  standard: '#B7B9BE',
  blue: '#669DF1',
  red: '#F87168',
  yellow: '#DDB30E',
  green: '#4BCE97',
  teal: '#6CC3E0',
  purple: '#C97CF4',
  lime: '#94C748',
  magenta: '#E774BB',
  orange: '#FCA700',
  grey: '#B7B9BE',
  standardLink: '#B7B9BE',
  blueLight: '#669DF1',
  redLight: '#F87168',
  yellowLight: '#DDB30E',
  greenLight: '#4BCE97',
  tealLight: '#6CC3E0',
  purpleLight: '#C97CF4',
  limeLight: '#94C748',
  magentaLight: '#E774BB',
  orangeLight: '#FCA700',
  greyLight: '#B7B9BE'
};

/**
 * With design tokens, hover colors do not change
 * compared to resting state. These are only here
 * for backwards compatibiltiy with legacy theming.
 * This can be removed when legacy theming is removed
 */
export var textHoverColors = {
  standard: "var(--ds-link, #0065FF)",
  blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
  red: "var(--ds-text-accent-red-bolder, #172B4D)",
  yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
  green: "var(--ds-text-accent-green-bolder, #172B4D)",
  teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
  purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
  lime: "var(--ds-text-accent-lime-bolder, #37471F)",
  magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
  orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
  grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
  blueLight: "var(--ds-text-accent-blue, #0747A6)",
  redLight: "var(--ds-text-accent-red, #42526E)",
  yellowLight: "var(--ds-text-accent-yellow, #42526E)",
  greenLight: "var(--ds-text-accent-green, #006644)",
  tealLight: "var(--ds-text-accent-teal, #42526E)",
  purpleLight: "var(--ds-text-accent-purple, #403294)",
  limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
  magentaLight: "var(--ds-text-accent-magenta, #943D73)",
  orangeLight: "var(--ds-text-accent-orange, #974F0C)",
  greyLight: "var(--ds-text-accent-gray, #42526E)"
};
export var textActiveColors = {
  standard: "var(--ds-link-pressed, #0065FF)",
  blue: "var(--ds-text-accent-blue, #172B4D)",
  red: "var(--ds-text-accent-red, #172B4D)",
  yellow: "var(--ds-text-accent-yellow, #172B4D)",
  green: "var(--ds-text-accent-green, #172B4D)",
  teal: "var(--ds-text-accent-teal, #172B4D)",
  purple: "var(--ds-text-accent-purple, #172B4D)",
  lime: "var(--ds-text-accent-lime, #4C6B1F)",
  magenta: "var(--ds-text-accent-magenta, #943D73)",
  orange: "var(--ds-text-accent-orange, #974F0C)",
  grey: "var(--ds-text-accent-gray, #FFFFFF)",
  blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
  redLight: "var(--ds-text-accent-red-bolder, #42526E)",
  yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
  greenLight: "var(--ds-text-accent-green-bolder, #006644)",
  tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
  purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
  limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
  magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
  orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
  greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};

// Background colors
export var backgroundColors = {
  standard: "var(--ds-background-neutral, #F4F5F7)",
  blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
  red: "var(--ds-background-accent-red-subtle, #FF8F73)",
  yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
  green: "var(--ds-background-accent-green-subtle, #57D9A3)",
  teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
  purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
  lime: "var(--ds-background-accent-lime-subtle, #94C748)",
  magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
  orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
  grey: "var(--ds-background-accent-gray-subtle, #42526E)",
  blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
  redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
  yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
  greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
  tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
  purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
  limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
  magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
  orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
  greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
export var linkHoverBackgroundColors = {
  standard: "var(--ds-background-neutral-hovered, #EBECF0)",
  blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
  red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
  yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
  green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
  teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
  purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
  lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
  magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
  orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
  grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
  blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
  redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
  yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
  greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
  tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
  purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
  limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
  magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
  orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
  greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
export var linkActiveBackgroundColors = {
  standard: "var(--ds-background-neutral-pressed, #EBECF0)",
  blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
  red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
  yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
  green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
  teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
  purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
  grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
  lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
  magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
  orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
  blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
  redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
  yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
  greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
  tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
  purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
  limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
  magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
  orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
  greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
export var focusRingColors = "var(--ds-border-focused, #4C9AFF)";
export var removalHoverBackgroundColors = "var(--ds-background-danger, #FFEBE6)";
export var removalActiveBackgroundColors = "var(--ds-background-danger-hovered, #FFEBE6)";
export var removalTextColors = "var(--ds-text-danger, #BF2600)";

/**
 * Remove button colors
 *
 * Once legacy theming support is dropped,
 * these can be removed and the remove button can inherit
 * from the tag text color
 */
export var removeButtonColors = {
  standard: "var(--ds-text, #42526E)",
  blue: "var(--ds-text-accent-blue-bolder, #42526E)",
  red: "var(--ds-text-accent-red-bolder, #42526E)",
  yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
  green: "var(--ds-text-accent-green-bolder, #42526E)",
  teal: "var(--ds-text-accent-teal-bolder, #42526E)",
  purple: "var(--ds-text-accent-purple-bolder, #42526E)",
  lime: "var(--ds-text-accent-lime-bolder, #42526E)",
  magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
  orange: "var(--ds-text-accent-orange-bolder, #42526E)",
  grey: "var(--ds-text-accent-gray-bolder, #42526E)",
  blueLight: "var(--ds-text-accent-blue, #42526E)",
  redLight: "var(--ds-text-accent-red, #42526E)",
  yellowLight: "var(--ds-text-accent-yellow, #42526E)",
  greenLight: "var(--ds-text-accent-green, #42526E)",
  tealLight: "var(--ds-text-accent-teal, #42526E)",
  purpleLight: "var(--ds-text-accent-purple, #42526E)",
  limeLight: "var(--ds-text-accent-lime, #42526E)",
  magentaLight: "var(--ds-text-accent-magenta, #42526E)",
  orangeLight: "var(--ds-text-accent-orange, #42526E)",
  greyLight: "var(--ds-text-accent-gray, #42526E)"
};
export var removeButtonHoverColors = {
  standard: "var(--ds-text-danger, #253858)",
  standardLink: "var(--ds-text-danger, #0052CC)",
  blue: "var(--ds-text-danger, #172B4D)",
  red: "var(--ds-text-danger, #172B4D)",
  yellow: "var(--ds-text-danger, #172B4D)",
  green: "var(--ds-text-danger, #172B4D)",
  teal: "var(--ds-text-danger, #172B4D)",
  purple: "var(--ds-text-danger, #172B4D)",
  lime: "var(--ds-text-danger, #172B4D)",
  magenta: "var(--ds-text-danger, #172B4D)",
  orange: "var(--ds-text-danger, #172B4D)",
  grey: "var(--ds-text-danger, #FFFFFF)",
  blueLight: "var(--ds-text-danger, #0747A6)",
  redLight: "var(--ds-text-danger, #42526E)",
  yellowLight: "var(--ds-text-danger, #42526E)",
  greenLight: "var(--ds-text-danger, #006644)",
  tealLight: "var(--ds-text-danger, #42526E)",
  purpleLight: "var(--ds-text-danger, #403294)",
  limeLight: "var(--ds-text-danger, #403294)",
  magentaLight: "var(--ds-text-danger, #403294)",
  orangeLight: "var(--ds-text-danger, #403294)",
  greyLight: "var(--ds-text-danger, #42526E)"
};